/**
 * @param form {string}
 * @param email {string}
 * @param marketoFormId {string}
 * @return {string}
 */
module.exports = function formsAtIterableComFormSubmissionSubject(form, email, marketoFormId) {
    return `[SUBMISSION] Form: ${form}, Email: ${email}, Form ID: ${marketoFormId}`;
}